var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"ripple",rawName:"v-ripple",value:('rgb(175, 223, 211, 0.15)'),expression:"'rgb(175, 223, 211, 0.15)'"}],style:({
    height: _vm.height,
    borderTop: _vm.noTopBorder ? '' : _vm.border,
    borderBottom: _vm.last ? _vm.border : '',
    backgroundColor: _vm.highlighted ? '#D9F0EA' : '',
    color: _vm.highlighted ? '#E05484' : null
  })},[(_vm.icon)?_c('img',{class:[{ 'pull-right': _vm.iconRight, icon: true }, _vm.iconClass],attrs:{"src":require('@/assets/icons/' + _vm.icon)}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }